/** Stable `editorStateMap` keys for planning comments; prefer these over string literals at call sites. */
export const planningMapKeys = {
  workstreamTable: {
    title: (workstreamId: number): string => String(workstreamId),
    description: (workstreamId: number): string => `${workstreamId}:description`,
    titleAndDescription: (workstreamId: number): string => `${workstreamId}:titleAndDescription`,
    /** `__columnHeader:*` so headers do not collide with numeric id keys */
    columnHeader: (columnType: string): string => `__columnHeader:${columnType}`,
    dri: (workstreamId: number): string => `${workstreamId}:dri`,
    nameAndDri: (workstreamId: number): string => `${workstreamId}:nameAndDri`,
  },
  embedOutcome: {
    title: (metricId: number): string => String(metricId),
    owner: (metricId: number): string => `${metricId}:owner`,
    /** Leading / lagging label in metrics meta row (planning embed comments). */
    metricSignal: (metricId: number): string => `${metricId}:metricSignal`,
    /** Combined metric title and leading/lagging owner meta in workstream table rows. */
    metricTitleAndMeta: (metricId: number): string => `${metricId}:metricTitleAndMeta`,
    /** Combined leading/lagging and owner metadata row in redesign metric rows. */
    metricMeta: (metricId: number): string => `${metricId}:metricMeta`,
    /** Combined leading/lagging label, metric title, and owner/current/target summary. */
    metricDetails: (metricId: number): string => `${metricId}:metricDetails`,
    eta: (metricId: number): string => `${metricId}:eta`,
    jiraEta: (jiraKey: string): string => `__jiraEta:${jiraKey}`,
    /** Combined outcome title and due/owner meta in workstream table rows. */
    outcomeTitleAndMeta: (outcomeKey: string): string => `${outcomeKey}:outcomeTitleAndMeta`,
    /** Combined due/owner metadata row in redesign outcome rows. */
    outcomeMeta: (outcomeKey: string): string => `${outcomeKey}:outcomeMeta`,
    /** Combined outcome title and due/owner summary in strategy kernel outcome rows. */
    outcomeDetails: (outcomeKey: string): string => `${outcomeKey}:outcomeDetails`,
    /** Compact "Current" / "Target" values in strategy kernel metric rows (planning embed). */
    currentDisplay: (metricId: number): string => `${metricId}:currentDisplay`,
    targetDisplay: (metricId: number): string => `${metricId}:targetDisplay`,
  },
  workingTeam: {
    roleLabel: (kind: string): string => kind,
    table: {
      columnHeader: (columnType: string): string => `__columnHeader:${columnType}`,
    },
  },
  strategyKernel: {
    table: {
      columnHeader: (columnType: string): string => `__columnHeader:${columnType}`,
    },
    objective: (workstreamId: number): string => `${workstreamId}:objective`,
  },
} as const;
